export default "__VITE_ASSET__BvFCFkob__"